module.exports = Jsw.skinUrl + "/icons/16/plesk/menu.png?a75a537332528331bb513a94e26d173d";